function AddVenueLayoutCtrl($scope, $state, alertService, sdkUtils, loggerService, layoutService) {
  if (!$scope.venueId) throw new Error('addVenueLayoutCtrl() - constructor - venueId is required on scope');

  _initScope();

  function _initScope() {
    $scope.venueLayoutForm = {
      venueId: $scope.venueId
    };

    if ($scope.venueLayout) {
      $scope.venueLayoutForm.name = $scope.venueLayout.name;
      if ($scope.venueLayout.floorPlan) {
        $scope.venueLayoutForm.image = $scope.venueLayout.floorPlan.small;
      }
    } else {
      $scope.venueLayoutForm.image = 'https://nightpro-classic.imgix.net/tQdd62BaR8WqEJiF4d9y_Default_Floorplan.jpg';
    }

    $scope.addOrUpdateVenueLayout = _addOrUpdateVenueLayout;
  }

  function _addOrUpdateVenueLayout(form, $event) {
    if (!form) return;
    if ($event) $event.preventDefault();

    $scope.submitted = true;

    if (!form.$valid) return;

    $scope.saving = true;

    if ($scope.venueLayoutForm.image) {
      $scope.venueLayoutForm.floorPlan = {
        small: $scope.venueLayoutForm.image,
        medium: $scope.venueLayoutForm.image,
        large: $scope.venueLayoutForm.image,
        xlarge: $scope.venueLayoutForm.image,
        original: $scope.venueLayoutForm.image
      };
    }

    const addOrUpdateVenueLayoutPromise = $scope.venueLayout ? layoutService.updateById($scope.venueLayout.id, $scope.venueLayoutForm) : layoutService.create($scope.venueLayoutForm);

    addOrUpdateVenueLayoutPromise
      .then(venueLayout => {
        if ($scope.onAddedOrUpdated) {
          $scope.onAddedOrUpdated({
            venueLayout
          });
        }
      })
      .catch(response => {
        alertService.error(sdkUtils.getErrorFromResponse(response));
      })
      .finally(() => {
        $scope.saving = false;
      });
  }
}

AddVenueLayoutCtrl.$inject = [
  '$scope',
  '$state',
  'alertService',
  'jsSdk.utils',
  'loggerService',
  'jsSdk.layout'
];

export default AddVenueLayoutCtrl;



// WEBPACK FOOTER //
// ./src/directives/addVenueLayout/controller.js